<template>
    <div class="container">
        <ul class=" menu-grande" v-bind:class="{ steps: steps, stepsM: stepsM}">
            <li class='step1' :class="{active: activeBtn === 'collect' ||  activeBtn === 'collectOn'}"><a href="" @click.prevent="scroll(ids[0])" title=""><em>{{ $t("107") }}</em><span><!-- OnInspector + Planning & Collection Control --></span></a></li>
            <li class='step2' :class="{active: activeBtn === 'reports' ||  activeBtn === 'result' }"><a href="" @click.prevent="scroll(ids[1])" title=""><em v-bind:class="{ marginM: marginM}">{{ $t("108") }}</em><span><!--Computer, Laboratory--></span></a></li>
            <li class='step3' :class="{active: activeBtn === 'defects' ||  activeBtn === 'defectsOn' }"><a href="" @click.prevent="scroll(ids[2])" title=""><em>{{ $t("109") }}</em><span><!-- Analysts --></span></a></li>
            <li class='step4' :class="{active: activeBtn === 'root' }"><a href="" @click.prevent="scroll(ids[3])" title=""><em v-bind:class="{ marginM: marginM}">{{ $t("110") }}</em><span><!-- Specialists --></span></a></li>
            <li class='step5' :class="{active: activeBtn === 'planning' }"><a href="" @click.prevent="scroll(ids[4])" title=""><em>{{ $t("111") }}</em><span><!-- Specialists + PCM --></span></a></li>
            <li class='step6' :class="{active: activeBtn === 'execution' }"><a href="" @click.prevent="scroll(ids[5])" title=""><em>{{ $t("112") }}</em><span><!-- Specialists + Office --></span></a></li>
            <li class='step7' :class="{active: activeBtn === 'mapa'}"><a href="" @click.prevent="scroll(ids[6])" title=""><em>{{ $t("113") }}</em><span></span></a></li>
        </ul>

        <ul class="menu-pequeno" v-bind:class="{ stepsMobile: stepsMobile}">
            <li class='step1' :class="{active: activeBtn === 'collect' ||  activeBtn === 'collectOn'}"><a href="" @click.prevent="scroll(ids[0])" title=""><em>{{ $t("107") }}</em><span><!-- OnInspector + Planning & Collection Control --></span></a></li>
            <li class='step2' :class="{active: activeBtn === 'reports' ||  activeBtn === 'result' }"><a href="" @click.prevent="scroll(ids[1])" title=""><em v-bind:class="{ marginM: marginM}">{{ $t("108") }}</em><span><!--Computer, Laboratory--></span></a></li>
            <li class='step3' :class="{active: activeBtn === 'defects' ||  activeBtn === 'defectsOn' }"><a href="" @click.prevent="scroll(ids[2])" title=""><em>{{ $t("109") }}</em><span><!-- Analysts --></span></a></li>
            <li class='step4' :class="{active: activeBtn === 'root' }"><a href="" @click.prevent="scroll(ids[3])" title=""><em v-bind:class="{ marginM: marginM}">{{ $t("110") }}</em><span><!-- Specialists --></span></a></li>
            <li class='step5' :class="{active: activeBtn === 'planning' }"><a href="" @click.prevent="scroll(ids[4])" title=""><em>{{ $t("111") }}</em><span><!-- Specialists + PCM --></span></a></li>
            <li class='step6' :class="{active: activeBtn === 'execution' }"><a href="" @click.prevent="scroll(ids[5])" title=""><em>{{ $t("112") }}</em><span><!-- Specialists + Office --></span></a></li>
            <li class='step7' :class="{active: activeBtn === 'mapa'}"><a href="" @click.prevent="scroll(ids[6])" title=""><em>{{ $t("113") }}</em><span></span></a></li>
        </ul>
    </div>

    
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
    name: 'bookmark',
    props: {
        ids: Array // lista de ids dos elementos âncora na ordem dos steps
    },
    data() {
        return {
            activeBtn: '',
            steps: true,
            stepsM: false,
            marginM: false,
            stepsMobile: true,
        }
    },
    methods:{
        scroll(element) {
            //console.log('element: ', element)
            this.activeBtn = element
            if (element)
                if( element == 'result' || element == 'reports' ){
                    element = 'collect'
                }
                // For older browsers, consider pulling in a polyfill.
                // https://www.npmjs.com/package/smoothscroll-polyfill
                document.querySelector('#' + element).scrollIntoView({ behavior: 'smooth' });
        }
    },
    computed: {
        ...mapGetters(['menu', 'getTab']),
    },
    watch: {
        menu: function(newValue){
            //console.log('scroll', this.menu.book)
            //aumenta e diminui o menu conforme o scroll
            if(this.menu.book > 30){                
                this.steps = false
                this.stepsM = true
                this.marginM = true
               
            }
            if(this.menu.book < 29){
                this.activeBtn = 'mapa'
                this.steps = true
                this.stepsM = false
                this.marginM = false
                
            }

            //marcando os menus qnd rola o scroll
            if(this.getTab == 'offline'){
                if(this.menu.book >= 1441 ){this.activeBtn = 'collect'} 
                if(this.menu.book >= 1914 ){this.activeBtn = 'planning'}
                if(this.menu.book >= 3195 ){this.activeBtn = 'defects'}
                if(this.menu.book >= 5809 ){this.activeBtn = 'execution'}
            }
            if(this.getTab == 'online'){
                if(this.menu.book >= 1326 ){this.activeBtn = 'collect'} 
                if(this.menu.book >= 2939 ){this.activeBtn = 'result'}
                if(this.menu.book >= 3419 ){this.activeBtn = 'defectsOn'}
                if(this.menu.book >= 5530 ){this.activeBtn = 'planning'}
                if(this.menu.book >= 6843 ){this.activeBtn = 'execution'}
            }

        },
        getTab: function(){
            //console.log('this.getTab: ', this.getTab)
        }
    }
}
</script>

<style scoped>
.container{
    width: 100%;
    margin: 10px auto 0px auto;
    padding: 0;
}
.container ul{
    margin: 0px auto!important;
}
.steps {
    padding: 0;
    overflow: hidden;
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
}
.steps a {
    color: white;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;
}
.steps em {
    display: block;
    font-size: 1.1em;
    font-weight: bold;
    font-style: normal;
    margin: 4px 0px;
    position: relative;
    top: 50%;
    transform: translateY(-80%);
}
.steps span{ font-size: 0.9em; }
.steps li {
    float: left;
    margin-left: 10px;
    /*width: 130px;*/
    width: 12.6%;
    height: 90px;
    list-style-type: none;
    padding: 7px 2px 0px 40px; 
    border-right: 3px solid #000;
    position: relative;
    text-align: center;
    vertical-align: middle;
}
.steps li:last-child {
    float: left;
    margin-left: 10px;
    width: 150px;
    height: 90px;
    list-style-type: none;
    padding: 7px 2px 0px 40px; 
    border-right: 3px solid #000;
    position: relative;
    text-align: center;
    vertical-align: middle;
}
.steps li:first-child {
    margin-left: 10px; /* somente para ajustar em mobile */
    padding-left: 5px;
}
.steps li:nth-child(n+2)::before {
    position: absolute;
    top:0;
    left:0;
    display: block;
    border-left: 35px solid #000; 
    border-top: 46px solid transparent; 
    border-bottom: 46px solid transparent; 
    width: 0;
    height: 0;
    content: " ";
}
.steps li::after {
    z-index: 1;
    position: absolute;
    top: 0;
    right: -35px;
    display: block;
    border-top: 46px solid transparent;
    border-bottom: 46px solid transparent;
    width:0;
    height:0;
    content: " ";
}

.steps li:last-child::after{ border: none !important; }

.steps li::after { border-left: 35px solid #134f69}
.steps li { background-color: #134f69}

.steps li:hover { background-color: #699bad; }
.steps li:hover::after{ border-left-color: #699bad; }

.steps li .active { background-color: #627c88!important; }
.active::after{ border-left-color: #627c88!important; }

/*MENU MENOR*/
.marginM{
    margin-top: 8px!important;
}
.stepsM {
    padding: 0;
    overflow: hidden;
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
}
.stepsM a {
    color: white;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;
}
.stepsM em {
    display: block;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    margin: 0px 0px;
    position: relative;
    top: 50%;
    transform: translateY(-80%);
}
.stepsM span{ font-size: 0.9em; }
.stepsM li {
    float: left;
    margin-left: 10px;
    width: 130px;
    height: 45px;
    list-style-type: none;
    padding: 7px 2px 0px 40px; 
    border-right: 3px solid #000;
    position: relative;
    text-align: center;
    vertical-align: middle;
}
.stepsM li:last-child {
    float: left;
    margin-left: 10px;
    width: 150px;
    height: 46px;
    list-style-type: none;
    padding: 7px 2px 0px 40px; 
    border-right: 3px solid #000;
    position: relative;
    text-align: center;
    vertical-align: middle;
}
.stepsM li:first-child {
    margin-left: 10px; /* somente para ajustar em mobile */
    padding-left: 5px;
}
.stepsM li:nth-child(n+2)::before {
    position: absolute;
    top:0;
    left:0;
    display: block;
    border-left: 35px solid #000; 
    border-top: 26px solid transparent; 
    border-bottom: 21px solid transparent; 
    width: 0;
    height: 0;
    content: " ";
}
.stepsM li::after {
    z-index: 1;
    position: absolute;
    top: 0;
    right: -35px;
    display: block;
    border-top: 26px solid transparent;
    border-bottom: 19px solid transparent;
    width:0;
    height:0;
    content: " ";
}

.stepsM li:last-child::after{ border: none !important; }

.stepsM li::after { border-left: 35px solid #134f69}
.stepsM li { background-color: #134f69}

.stepsM li:hover { background-color: #699bad; }
.stepsM li:hover::after{ border-left-color: #699bad; }

.stepsM li .active { background-color: #627c88!important; }

.menu-pequeno{
    display: none;
}

.stepsMobile {
    padding: 0;
    overflow: hidden;
    position: relative;
    /*display: inline-block;*/
    left: 50%;
    transform: translateX(-50%);
}
.stepsMobile a {
    color: white;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;
}
.stepsMobile em {
    display: block;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    margin: 4px 0px;
    position: relative;
    top: 50%;
    transform: translateY(-80%);
}
.stepsMobile span{ font-size: 0.9em; }
.stepsMobile li {    
    width: 32.6%;
    float: left;
    height: 30px;
    list-style-type: none;
    padding: 2px 2px; 
    text-align: center;
    vertical-align: middle;
    margin: 1px 1px;
}
.stepsMobile li:last-child {
    width: 98.5%;
    float: left;
    height: 30px;
    list-style-type: none;
    padding: 2px 2px; 
    text-align: center;
    vertical-align: middle;
}

.stepsMobile li:nth-child(n+2)::before {   
    top:0;
    left:0;
    display: block;
    width: 0;
    height: 0;
    content: " ";
}
.stepsMobile li::after {
    z-index: 1;
    top: 0;
    display: block;
    width:0;
    height:0;
    content: " ";
}


.stepsMobile li { background-color: #134f69}

.stepsMobile li:hover { background-color: #699bad; }

.stepsMobile li .active { background-color: #627c88!important; }

@media screen and (max-width: 1355px) {
    .stepsM li{
        width: 100px;        
    }

    .stepsM em{
        font-size: 10px;    
    }
}
@media screen and (max-width: 1220px) {
   .steps li{
        margin-left: 5px;      
   }
}
@media screen and (max-width: 1175px) {
    .menu-grande{
      display: none;
    }
    .menu-pequeno{
      display: block;
    }
} 

@media screen and (max-width: 650px) {
    .stepsMobile{
       left: 47%;
    }
}  
@media screen and (max-width: 420px) {
    .stepsMobile li:last-child {
        width: 99.5%;
    }
    .step4{
        padding-top: 10px!important;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/Bookmark.vue